/**

 * Bottom sheet — detalhe da turma (mobile).

 */

import { X } from 'lucide-react';

import { useNavigate } from 'react-router-dom';

import { ProfessorTurmaPainel } from './ProfessorTurmaPainel';



const TURNO: Record<string, string> = {

  MANHA: 'Manhã',

  TARDE: 'Tarde',

  NOITE: 'Noite',

  INTEGRAL: 'Integral',

};



export interface TurmaDetalheData {

  id: string;

  nome: string;

  serie?: string;

  turno?: string;

  sala?: string;

  totalAlunos: number;

  aulasSemana: number;

  aulasHoje: number;

  materias: Set<string>;

  chamadaHojeFeita: boolean;

  chamadaHojePres: number;

  chamadaHojeTotal: number;

}



interface GradeDia {

  key: string;

  label: string;

  aulas: Array<{

    id: string;

    horaInicio?: string;

    horaFim?: string;

    materia?: { nome?: string };

  }>;

}



interface AlunoResumo {

  id: string;

  nome: string;

}



interface Props {

  turma: TurmaDetalheData | null;

  grade: GradeDia[];

  diaSemanaHoje?: string | null;

  alunos: AlunoResumo[];

  loadingAlunos?: boolean;

  onClose: () => void;

}



export function TurmaDetalheSheet({

  turma: t,

  grade,

  diaSemanaHoje,

  alunos,

  loadingAlunos,

  onClose,

}: Props) {

  const navigate = useNavigate();

  if (!t) return null;



  return (

    <div className="comunicado-sheet-overlay" onClick={onClose} role="presentation">

      <div

        className="comunicado-sheet-panel turma-sheet-panel"

        onClick={(e) => e.stopPropagation()}

        role="dialog"

        aria-labelledby="turma-sheet-title"

      >

        <div className="comunicado-sheet-handle" aria-hidden />



        <div className="comunicado-sheet-header">

          <div style={{ flex: 1, minWidth: 0 }}>

            <h2 id="turma-sheet-title" className="comunicado-sheet-title">

              {t.nome}

            </h2>

            <p className="comunicado-sheet-meta-line">

              {[t.serie, t.turno ? TURNO[t.turno] || t.turno : '', t.sala]

                .filter(Boolean)

                .join(' · ')}

            </p>

          </div>

          <button

            type="button"

            className="comunicado-sheet-close"

            onClick={onClose}

            aria-label="Fechar"

          >

            <X size={18} />

          </button>

        </div>



        <div className="turma-sheet-scroll">

          <ProfessorTurmaPainel

            turma={t}

            grade={grade}

            diaSemanaHoje={diaSemanaHoje}

            alunos={alunos}

            loadingAlunos={loadingAlunos}

            variant="sheet"

            onAlunoClick={(id) => {

              onClose();

              navigate(`/professor/alunos/${id}`);

            }}

            onBeforeChamada={onClose}

          />

        </div>

      </div>

    </div>

  );

}


